import { useLazyQuery } from '@apollo/react-hooks';
import { FacebookPixelQuery, FacebookPixelQueryVariables } from './__generated__/FacebookPixelQuery';
import { client } from 'api';
import { FB_PIXEL_QUERY } from './facebookPixel.query';

export const FBPixelQuery = (variables: FacebookPixelQueryVariables, signal: AbortSignal) => {
  return client.query<FacebookPixelQuery, FacebookPixelQueryVariables>({
    query: FB_PIXEL_QUERY,
    variables,
    fetchPolicy: 'network-only',
    context: {
      fetchOptions: {
        signal: signal
      }
    }
  });
};

export const useLazyFBPixelQuery = () =>
  useLazyQuery<FacebookPixelQuery, FacebookPixelQueryVariables>(FB_PIXEL_QUERY, {
    fetchPolicy: 'network-only'
  });
